import React from 'react'
import search from '../images/search.png'
import time from '../images/time.png'
import live from '../images/live.png'
const ThankYouCampaign = () => {
  return (
    <div className="min-h-screen relative font-poppins px-4  md:px-20 py-20   bg-gradient-to-b to-[#191E5B] from-[#A787FF]">
        <p className="md:text-6xl text-3xl font-bold text-center mt-20 text-white">Thank You</p>
        <p className="md:text-xl text-lg mt-5 text-center text-white">  for your interest in Northstarz.Ai. Our team will reach out to you shortly</p>

        <div className="mt-40 gap-10 space-y-10 md:space-y-0 md:grid grid-cols-3">
            <div>
                <div className="flex items-center space-x-2">
                    <img src={search} className="invert h-10"></img>
                    <p className="text-white font-bold text-2xl">Screen 8x more candidates</p>
                </div>
                <p className="text-white opacity-90 mt-2 text-sm">Some of the best candidates are busy during work hours. Engage more quality candidates by allowing them to interview with our AI Video recruiter at the time that works best for them, including nights and weekends.</p>
            </div>
            <div>
                <div className="flex items-center space-x-2">
                    <img src={time} className="invert h-10"></img>
                    <p className="text-white font-bold text-2xl">Hire 87% faster</p>
                </div>
                <p className="text-white opacity-90 mt-2 text-sm">Our AI can interview multiple candidate at once, so you can screen your candidates without worrying about double booking or schedule conflicts.</p>
            </div>
            <div>
                <div className="flex items-center space-x-2">
                    <img src={live} className="invert h-10"></img>
                    <p className="text-white font-bold text-2xl">Interview 70% cheaper</p>
                </div>
                <p className="text-white opacity-90 mt-2 text-sm">Engage more candidates with interview reminders, scheduling deadlines, and follow-up cadences to increase maximize top-of-funnel.</p>
            </div>
        </div>
    </div>
  )
}

export default ThankYouCampaign